import store from '@/store'
import storageService from '@/services/storageService'
import isExtranetHostname from '@/helpers/isExtranet'
import { resetSessionFlag } from '@/services/axiosInterceptor'

let verified = false
let expiring = null

export const isSessionVerified = () => verified
export const markSessionVerified = () => { verified = true }
export const resetSessionVerified = () => { verified = false }

export function resolveLoginPath(path = '') {
  if (isExtranetHostname() || path.startsWith('/extranet')) return '/extranet/login'
  const level = localStorage.getItem('level') || ''
  if (path.startsWith('/client') || path === '/point-info' || level.includes('member')) return '/member/login'
  return '/login'
}

// Idempotent: dipanggil dari guard dan event bersamaan pun hanya jalan sekali
export function expireSession(currentPath = window.location.pathname) {
  if (expiring) return expiring
  const target = resolveLoginPath(currentPath) // hitung SEBELUM data dihapus

  expiring = (async () => {
    try { await store.dispatch('Auth/expireLocal') } catch (e) { /* boleh gagal */ }
    try { await storageService.clearAuthData() } catch (e) { /* abaikan */ }
    localStorage.removeItem('token')
    verified = false
    resetSessionFlag()
    return target
  })().finally(() => { expiring = null })

  return expiring
}